import 'babel-polyfill'
import axios from 'axios';

import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'

import './plugins/vuetify'
import "./registerServiceWorker"
// import 'typeface-heebo'
// import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false;

import themes from '@/data/themes'
Vue.prototype.themes = themes
import easings from './easing'
Vue.prototype.easings = easings

/* Error Tracking */
// import * as Sentry from '@sentry/browser'
// import { Vue as VueIntegration } from '@sentry/integrations'
// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn: process.env.VUE_APP_SENTRY_DSN,
//     integrations: [new VueIntegration({ Vue, attachProps: true })],
//   })
// }

/* Authentication */
const axiosInstance = axios.create({ baseURL: process.env.VUE_APP_API_ROOT })
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
Vue.use(VueAxios, axiosInstance)
// Provide a global Vue.$http alias so components using Vue.$http continue to work
Vue.$http = axiosInstance
Vue.use(VueAuthenticate, {
  providers: {
    google: {
      clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID,
      url: '/candidate/auth/google',
    },
    facebook: {
      clientId: process.env.VUE_APP_FACEBOOK_OAUTH_CLIENT_ID,
      authorizationEndpoint: 'https://www.facebook.com/v2.12/dialog/oauth',
      url: '/candidate/auth/facebook',
    },
    linkedin: {
      clientId: process.env.VUE_APP_LINKEDIN_OAUTH_CLIENT_ID,
      scope: ['r_liteprofile', 'r_emailaddress'],
      url: '/candidate/auth/linkedin',
      requiredUrlParams: ['state', 'scope'],
    },
  },
})
axiosInstance.interceptors.response.use(function(response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  if (response.headers.authorization) {
    // Update the token with the new one provided to extend the session
    const token = response.headers.authorization.substring(7) // strip "Bearer "
    window.Vue.$auth.setToken({ access_token: token })
  }
  return response;
}, function(error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  if (error.response.status === 401) {
    if (window.Vue.$auth.getPayload()) {
      const { exp } = window.Vue.$auth.getPayload()
      const now = Math.floor(Date.now() / 1000)
      if (exp < now) {
        window.Vue.$store.dispatch('auth/logOut')
        window.Vue.$store.dispatch('snackbarError', 'You have been logged out due to inactivity.')
        window.Vue.$router.push('/login')
      }
    }
  }
  return Promise.reject(error);
});

/* Crisp */
window.$crisp = ['safe', true]
window.CRISP_READY = false
window.CRISP_READY_TRIGGER = () => (window.CRISP_READY = true)

/* Leaflet Maps */
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

delete Icon.Default.prototype._getIconUrl // this part resolve an issue where the markers would not appear

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

/* Charts */
import ApexCharts from 'vue-apexcharts'
Vue.use(ApexCharts)
Vue.component('apex', ApexCharts)

/* Vue Clipboard 2 */
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

/* Vue Filters */
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)
import currency from './filters/currency'
Vue.use(currency)
// Standard $date and (… | date)
import VueDateFns from 'vue-date-fns'
Vue.use(VueDateFns)
// $inWords and (… | inWords)
import { formatDistance } from 'date-fns'
function inWordsFilter(date, opts) {
  if (!date) return ""
  if (opts) {
    opts['to'] = opts['to'] || new Date()
    if (typeof opts['to'] == 'string') opts['to'] = new Date(opts['to'])
    opts['addSuffix'] = opts['addSuffix'] || false
    return formatDistance(new Date(date), opts.to, { includeSeconds: true, addSuffix: opts.addSuffix })
  } else {
    return formatDistance(new Date(date), new Date(), { includeSeconds: true, addSuffix: false })
  }
};
Vue.filter('inWords', inWordsFilter)
Vue.mixin({ methods: { '$inWords': inWordsFilter } })

/* Vue directives */
import VueImgOrientationChanger from 'vue-img-orientation-changer'
Vue.use(VueImgOrientationChanger)

/* VueX Store */
import store from './store'

/* Router */
import router from './router'
Vue.router = router

/* Google Analytics */
import VueAnalytics from 'vue-analytics'
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-50695091-1',
    router,
    debug: { sendHitTask: true },
  })
}

/* App SCSS */
import './assets/style/app.scss'

/* App component and global components */
import DatePicker from '@/components/DatePicker'
Vue.component('date-picker', DatePicker)
import DateRangePicker from '@/components/DateRangePicker'
Vue.component('date-range-picker', DateRangePicker)
import LeaplyMap from '@/components/maps/LeaplyMap'
Vue.component('leaply-map', LeaplyMap)

import App from './App.vue'

// Monkeypatch!
String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

// Remove Spinner Mixin
Vue.mixin({
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!/^\/campaign/.test(to.path)) {
        let spinner = document.getElementById("spinner-wrapper")
        if (spinner) spinner.classList.add("fadeToNothing");
      }
    })
  },
})

new Vue({
  el: '#leaply',
  props: { root: { type: String, default: () => process.env.VUE_APP_ROOT } },
  created() {
    // Attach the Vue instance to the window, so it's available globally.
    window.Vue = this
    this.$env = process.env.NODE_ENV
    // Check the token and hydrate user data if needed
    this.$store.dispatch('auth/refresh')
    // Set the API root in case views need links to the API
    this.$api = process.env.VUE_APP_API_ROOT
  },
  mounted() {
    if (process.env.NODE_ENV === 'production') {
      window.CRISP_WEBSITE_ID = process.env.VUE_APP_CRISP_WEBSITE_ID
      window.CRISP_COOKIE_EXPIRE = 3600
      const script = document.createElement('script')
      script.src = 'https://client.crisp.chat/l.js'
      script.async = 1
      document.getElementsByTagName('head')[0].appendChild(script)
    }
  },
  router,
  store,
  render: h => h(App),
})
